module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('v-form-table', {
    attrs: {
      "form": _vm.form,
      "list": _vm.exceptionList,
      "create": _vm.save,
      "destroy": _vm.destroy,
      "translation": "table.businessHourExceptions"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0ac72aa","hasScoped":false}!./src/app/components/exceptionalHours/exceptionalHours.html
// module id = 3136
// module chunks = 1